import { saveAs } from 'file-saver';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(protected http: HttpClient) {}

  saveFile(data: any, filename?: string) {
    let typeData = 'text/csv; charset=utf-8';
    if (filename.match('.pdf')) {
      typeData = 'application/pdf';
    } else if (filename.match('.xml')) {
      typeData = 'application/xml';
    } else if (filename.match('.zip')) {
      typeData = 'application/zip';
    } else if (filename.match('.xlsx') || filename.match('.xls')) {
      typeData = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    const blob = new Blob([data], { type: typeData });
    saveAs(blob, filename);
  }

  getBlobFile(url: string) {
    const headers = new HttpHeaders();
    return this.http.get(url, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    });
  }
}
